import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { API, Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import './Level3.scss';
import StorePage from '../Store/Store'
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import Coin from '../Coin/Coin'
import Celebrate from '../Celebrate/Celebrate';
import Game from '../PressYourLuck/Game'
import Animal from '../Animal/Animal'
import Store from '../Store/store.jpg'
import Intro from '../Conversation/Intro';
import Friends from '../Record/Friends'
import Valuation from '../Conversation/Valuation'
import Share from '../Conversation/Share'
import Surprise from '../SurpriseVideo/surprise';
import Draggable from 'react-draggable';
import presentSound from "./../../Unit1/Module1/assets/ta_da_gift.mp3"
import MatchGame from './MatchGame'

const Level3 = (props) => {
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const { freeplay } = useSelector((state) => state.freeplay, shallowEqual);
    const firstUpdate = useRef(true);
    const dispatch = useDispatch();
    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;


    const [clientHeight, setVh] = useState(window.innerHeight);
    const [clientWidth, setVw] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setVh(window.innerHeight);
        setVw(window.innerWidth);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [clientHeight, clientWidth]);

    function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    const navigate = useNavigate();
    const [displayDecorate, setDisplayDecorate] = useState(props.decorate || props.store);
    const [displayStep0, setDisplayStep0] = useState(!props.decorate && !props.store);
    const [displayStep1, setDisplayStep1] = useState(false);
    const [displayStep2, setDisplayStep2] = useState(false);
    const [displayStep3, setDisplayStep3] = useState(false);
    const [displayStep4, setDisplayStep4] = useState(false);
    const [displayStore, setDisplayStore] = useState(props.store);
    const [displayStoreCharacter, setDisplayStoreCharacter] = useState(false);
    const [storeReady, setStoreReady] = useState(false);

    const [selectedStudentCharacter, setSelectedStudentCharacter] = useState(null)
    const [selectedFriendCharacter, setSelectedFriendCharacter] = useState(null)
    const [celebrateText, setCelebrateText] = useState('');
    const [celebrateVoice, setCelebrateVoice] = useState('');
    const [displaySurpriseVideoIcon, setDisplaySurpriseVideoIcon] = useState(false);
    const [displaySurpriseVideo, setDisplaySurpriseVideo] = useState(false);
    const [surpriseVideo, setSurpriseVideo] = useState("");
    const [prize, setPrize] = useState(false);

    const [displayCoin, setDisplayCoin] = useState(false);
    const [displayValuation, setDisplayValuation] = useState(false);
    const [displayCelebrate, setDisplayCelebrate] = useState(false);
    const [displayCoinAfterConversation, setDisplayCoinAfterConversation] = useState(false);
    const [valuationQuestions, setValuationQuestions] = useState(null);
    const [displayCoinAfterValuation, setDisplayCoinAfterValuation] = useState(false);
    const [displayMatchGame, setDisplayMatchGame] = useState(false);
    const [displayCoinAfterMatchGame, setDisplayCoinAfterMatchGame] = useState(false);
    const [displayCoinAfterCelebrate, setDisplayCoinAfterCelebrate] = useState(false);
    const [displayGame, setDisplayGame] = useState(false);
    const [displayShare, setDisplayShare] = useState(false);
    const [displayAnimal, setDisplayAnimal] = useState(false);
    const [animal, setAnimal] = useState('');
    const [animals, setAnimals] = useState([]);
    const [topicName, setTopicName] = useState('');
    const [change, setChange] = useState(false);
    const [practice, setPractice] = useState(false);
    const [topics, setTopics] = useState(null);
    const [conversationNum, setConversationNum] = useState(-1);
    const [conversationName, setConversationName] = useState('');
    const influencers = [login.influencerid, login.influencerid1,login.influencerid2,login.influencerid3,login.influencerid4,login.influencerid, login.influencerid1,login.influencerid2,login.influencerid3,login.influencerid4]
    const giftBtn = generateImageUrl('images/Images/Gift.png', login);
    const playIcon = generateImageUrl('images/newDesign/FreePlay/play.png')
    const rewardSound = new Audio(presentSound);
    const conversationNames = ['favorite', 'feeling', 'listening', 'friends', 'solution', 'conflict', 'advocacy', 'community']

    const updateFreeplay = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				name: "level3",
				coin: freeplay.level3Coin,
				progress: JSON.stringify(freeplay.level3),
                decorate: JSON.stringify(freeplay.level3Decorate)
			},
		}
		await API.put('TIR', '/v3/student/freeplay', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
        const myInit2 = {
            body: {
              id: login.studentid,
              current_module: 'Level3',
            },
          };
          await API.put('TIR', '/v3/student', myInit2)
          .then((response) => {
          })
          .catch((error) => {
          });
	})

    const getNestedLength = (obj) => {
        let length = 0;
        Object.values(obj).forEach(value => {
            Object.values(value).forEach(module => {
                if (module.unlocked === 1) {
                    length += 1
                }
            });
        });
        return length;
    };
    
    const updateProgress = (async () => {
        const totalLength = getNestedLength(freeplay.level3);
		const payload = {
			body: {
				id: login.studentid,
				module: `Level3`,
				day_completed: totalLength,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

    const getAnimalData = async (levelName, unlockedCount, animalName, className) => {
        if (Object.values(freeplay.level3[levelName]).filter(value => value.unlocked === 1).length === unlockedCount) {
            let photo;
            await GetUserVideo(`userfiles/${login.studentid}/level3_${levelName}_animal.png`).then((data) => {
                photo = data
            });
            await fetch(photo).then((response) => {
                if (response.status === 200) {
                    let item = {
                        img: photo,
                        name: levelName,
                        animal: animalName,
                        className: className,
                        coin: 0
                    };

                    // Update the boughts array
                    boughts.forEach(existingItem => {
                        if (existingItem.name === levelName) {
                            existingItem.url = photo;
                        }
                    });

                    // Update or add item in the animals array
                    const foundItem = animals.find(existingItem => existingItem.name === levelName);
                    if (foundItem) {
                        foundItem.img = photo;
                    } else {
                        animals.push(item);
                    }

                    // Update the state
                    setBoughts(boughts);
                    setAnimals(animals);
                }
            });
        }
    };
    
    const getAnimals = async () => {
        const animalConfigurations = [
            { levelName: "favorite", unlockedCount: 5, animalName: "bird", className: "bird3" },
            { levelName: "feeling", unlockedCount: 6, animalName: "dinossaur", className: "dinossaur"},
            { levelName: "listening", unlockedCount: 6, animalName: "duck", className: "duck"},
            { levelName: "friends", unlockedCount: 5, animalName: "giraffe", className: "giraffe"},
            { levelName: "solution", unlockedCount: 3, animalName: "monkey", className: "monkey3"},
            { levelName: "conflict", unlockedCount: 5, animalName: "starfish", className: "starfish"},
            { levelName: "advocacy", unlockedCount: 5, animalName: "trex", className: "trex"},
            { levelName: "community", unlockedCount: 10, animalName: "zebra", className: "zebra"}
        ];
    
        // Iterate over each animal configuration and call the function
        for (const config of animalConfigurations) {
            try{
                await getAnimalData(config.levelName, config.unlockedCount, config.animalName, config.className);
            }
            catch(error){}
        }
        setStoreReady(true);
    };
    
    useEffect(() => {
        const fetchData = async () => {
            let modules = ['favorite', 'feeling', 'listening', 'friends', 'solution', 'conflict', 'advocacy', 'community'];
            
            // Loop through boughts and fetch data if necessary
            for (let item of boughts) {
                if (modules.includes(item.name)) {
                    try {
                        // Await the fetch to check the URL status
                        const response = await fetch(item.url);

                        // If the response is not OK (status !== 200), fetch the new image
                        if (response.status !== 200) {
                            const data = await GetUserVideo(`userfiles/${login.studentid}/level3_${item.name}_animal.png`);
                            item.url = data; // Directly update the URL property
                        }
                    } catch (error) {
                        // In case of an error, attempt to get the video
                        const data = await GetUserVideo(`userfiles/${login.studentid}/level3_${item.name}_animal.png`);
                        item.url = data; // Directly update the URL property
                    }
                }
            }
            
            // After processing all items, update the state with a new reference
            setBoughts([...boughts]); // Trigger re-render with updated state
        };
    
        fetchData();
    }, []);

    useEffect(() => {
        if(displayStore){
            getAnimals();
        }
    }, [displayStore]);
    

    const backgrounds = [generateImageUrl('images/Module11Images/Unit3_Mod1_Background-1.png'), 
                         generateImageUrl('images/Module12Images/Unit3_Mod2BG.png'),
                         generateImageUrl('images/Module8Images/Module8NavImages/Background_JourneyMap_Unit2_Mod3.png'),
                         generateImageUrl('images/Module14Images/Background14-01.png'),
                         generateImageUrl('images/Module15Images/m15-BG-chromebook.png')]
    const [bgIdx, setBgIdx] = useState(freeplay.level3Decorate.background);

    const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png')
    const greenCheckSound = new Audio(generateImageUrl('media/Module1Videos/button_accept_item.mp3'))
    const Exit = generateImageUrl('images/Images/close.png')
    const coin = generateImageUrl('images/Images/Coin_Empty.png');


    let buys = [
        {
            img: 'images/Module1Images/Reward_SurfBoardBlue.svg',
            name: "SurfBoardBlue",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_SurfBoardRed.svg',
            name: "SurfBoardRed",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_BeachBall.svg',
            name: "FloatationBall",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_Bucket.svg',
            name: "SandBucket",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_Glasses.svg',
            name: "CrabWearGlasses",
            coin: 8
        },
        {
            img: 'images/Module1Images/Reward_Mustache.svg',
            name: "CrabWearMustache",
            coin: 8
        },
        {
            img: 'images/Module1Images/Reward_StarFish.svg',
            name: "SeashellsRed",
            coin: 4
        },
        {
            img: 'images/Module1Images/Reward_Shell.svg',
            name: "SeashellsGreen",
            coin: 4
        },
        {
            img: 'images/Module2Images/Reward_BikeSpringChair.png',
            name: "SpringToy",
            coin: 10
        },
        {
            img: 'images/Module5Images/Reward_TireSwing.png',
            name: "TireSwing",
            coin: 6
        },
        {
            img: 'images/Module2Images/Reward_MonkeyBarsBlue.png',
            name: "MonkeybarsBlue",
            coin: 10
        },
        {
            img: 'images/Module2Images/Reward_MonkeyBarYellow.png',
            name: "MonkeybarsYellow",
            coin: 10
        },
        {
            img: 'images/Module2Images/Reward_KitePink.png',
            name: "KitePink",
            coin: 6
        },
        {
            img: 'images/Module2Images/Reward_KitePurple.png',
            name: "KitePurple",
            coin: 6
        },
        {
            img: 'images/Module3Images/Reward_Tent1.png',
            name: "Tent",
            coin: 10
        },
        {
            img: 'images/Module3Images/Reward_Tent2.png',
            name: "TentOld",
            coin: 10
        },
        {
            img: 'images/Module3Images/Reward_Backpack.png',
            name: "Backpack",
            coin: 6
        },
        {
            img: 'images/Module3Images/Reward_Cantina.png',
            name: "Canteen",
            coin: 4
        },
        {
            img: 'images/newDesign/FreePlay/rewards/cowboyHat.png',
            name: "Hat",
            coin: 8
        },
        {
            img: 'images/newDesign/FreePlay/rewards/bandana.png',
            name: "Bandanna",
            coin: 8
        },
        {
            img: 'images/Module4Images/Reward_Zebras.png',
            name: "Zebras",
            coin: 12
        },
        {
            img: 'images/Module4Images/Reward_Car2.png',
            name: "JeepBlue",
            coin: 10
        },
        {
            img: 'images/Module4Images/Reward_Car.png',
            name: "JeepPink",
            coin: 10
        },
        {
            img: 'images/Module4Images/Reward_BirdColors.png',
            name: "Parrot",
            coin: 6
        },
        {
            img: 'images/newDesign/FreePlay/rewards/tucan.png',
            name: "Tucan",
            coin: 6
        },
        {
            img: 'images/Module4Images/Reward_Cheetah.png',
            name: "Cheetah",
            coin: 12
        },
        {
            img: 'images/Module5Images/Reward_BirdhouseBlue.png',
            name: "TreeHouseBlue",
            coin: 10
        },
        {
            img: 'images/Module5Images/Reward_BirdhousePink.png',
            name: "TreeHouseRed",
            coin: 10
        },
        {
            img: 'images/Module5Images/Reward_TelescopeBlue.png',
            name: "TelescopeBlue",
            coin: 4
        },
        {
            img: 'images/Module5Images/Reward_TelescopeRed.png',
            name: "TelescopeRed",
            coin: 4
        },
        {
            img: 'images/newDesign/FreePlay/rewards/buck.png',
            name: "Deer",
            coin: 12
        },
        {
            img: 'images/Module5Images/Reward_DeerFemale.png',
            name: "Doe",
            coin: 12
        },
        {
            img: 'images/Module5Images/Reward_WoodenSwing.png',
            name: "Swing",
            coin: 6
        },
        { img: 'images/Module6Images/DailyReward_SeaweedGreen@3x.png', name: "SeaweedGreen", coin: 4 },
        { img: 'images/Module6Images/DailyReward_SeaweedBrown@3x.png', name: "SeaweedBrown", coin: 4 },
        { img: 'images/Module6Images/DailyReward_BluePearl.png', name: "ClamBlue", coin: 4 },
        { img: 'images/Module6Images/DailyReward_PinkPearl.png', name: "ClamPink", coin: 4 },
        { img: 'images/Module6Images/DailyReward_CoralRed.png', name: "CoralRed", coin: 4 },
        { img: 'images/Module6Images/DailyReward_CoralBlue.png', name: "CoralBlue", coin: 4 },
        { img: 'images/Module6Images/DailyReward_Mermaid1.png', name: "MermaidBlue", coin: 6 },
        { img: 'images/Module6Images/DailyReward_Mermaid2.png', name: "MermaidRed", coin: 6 },
        { img: 'images/newDesign/FreePlay/rewards/BigReward_InsideCir_Castle.png', name: "SandCastle", coin: 10 },
        { img: 'images/Module6Images/BigReward_Treasure.svg', name: "Treasure", coin: 12 },
        { img: 'images/Module7Images/DailyReward_Gnome1.png', name: "GnomeBlue", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Flower_Pink.png', name: "FlowerPink", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Flower_Blue.png', name: "FlowerBlue", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Fairy1.png', name: "FairyPurple", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Fireflies_Pink.png', name: "FireflyPink", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Frog_Crown2.png', name: "CrownRound", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Fairy2.png', name: "FairyGreen", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Gnome2.png', name: "GnomeGreen", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Frog_Crown1.png', name: "CrownSpike", coin: 6 },
        { img: 'images/Module7Images/BigReward_Fae_Dragon.png', name: "FaeDragon", coin: 12 },
        { img: 'images/Module7Images/BigReward_Fae_House.png', name: "FaeHouse", coin: 10 },
        { img: 'images/Module8Images/DailyReward_Stego_Blue.png', name: "StegoBlue", coin: 6 },
        { img: 'images/Module8Images/DailyReward_DinoLongNeck_Green.png', name: "LongNeckGreen", coin: 8 },
        { img: 'images/Module8Images/DailyReward_DinoLongNeck_Red.png', name: "LongNeckRed", coin: 8 },
        { img: 'images/Module8Images/DailyReward_Raptor_LightBlue.png', name: "RaptorLight", coin: 6 },
        { img: 'images/Module8Images/DailyReward_Stego_Green.png', name: "StegoGreen", coin: 6 },
        { img: 'images/Module8Images/DailyReward_Raptor_Darker.png', name: "RaptorDark", coin: 8 },
        { img: 'images/Module8Images/DailyReward_Plant1.png', name: "Plant1", coin: 4 },
        { img: 'images/Module8Images/DailyReward_Plant2.png', name: "Plant2", coin: 4 },
        { img: 'images/Module8Images/DailyReward_DinoFlying_Purple.png', name: "DinoFlyingPurple", coin: 8 },
        { img: 'images/newDesign/Unit2Module8/BigRewardVolcanoNoSmoke.png', name: "Volcano", coin: 10 },
        { img: 'images/Module8Images/BigReward_TRex@2x.png', name: "TRex", coin: 12 },
        { img: 'images/Module9Images/DailyReward_Horse2.png', name: "Horse2", coin: 6 },
        { img: 'images/Module9Images/DailyReward_Hat1.png', name: "Hat1", coin: 8 },
        { img: 'images/Module9Images/DailyReward_Horse1.png', name: "Horse1", coin: 6 },
        { img: 'images/Module9Images/DailyReward_Pheonix.png', name: "Pheonix", coin: 8 },
        { img: 'images/Module9Images/DailyReward_Hat2.png', name: "Hat2", coin: 8 },
        { img: 'images/Module9Images/DailyReward_Yeti_Brown.png', name: "YetiBrown", coin: 6 },
        { img: 'images/Module9Images/DailyReward_Yeti.png', name: "Yeti", coin: 6 },
        { img: 'images/Module9Images/DailyReward_Dragon.png', name: "Dragon", coin: 8 },
        { img: 'images/Module9Images/BigReward_Castle.png', name: "MedievalCastle", coin: 12 },
        { img: 'images/Module10Images/DailyReward_CometOrange.png', name: "CometOrange", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Alien2.png', name: "Alien2", coin: 6 },
        { img: 'images/Module10Images/DailyReward_Planet1.png', name: "Planet1", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Planet2.png', name: "Planet2", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Alien1.png', name: "Alien1", coin: 6 },
        { img: 'images/Module10Images/DailyReward_Rocket1.png', name: "Rocket1", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Rocket2.png', name: "Rocket2", coin: 8 },
        { img: 'images/Module10Images/DailyReward_CometBlue.png', name: "CometBlue", coin: 8 },
        { img: 'images/Module10Images/BigReward_Galaxy.png', name: "Galaxy", coin: 12 },
      ];
      
      
    buys = buys.sort((a, b) => a.coin - b.coin);

    const [boughts, setBoughts] = useState(freeplay.level3Decorate.items);

    const [update, setUpdate] = useState(false);


    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
        } else {
            updateFreeplay();
        }
    }, [freeplay.level3Coin, freeplay.level3, update]);

    const setConversation = (num, name) => {
        document.querySelectorAll('.option').forEach(function(element) {
            element.style.border= '';
        })
        let element = document.getElementsByClassName('option')[num]
        element.style.border= '2px solid yellow';
        setConversationName(name);
        setConversationNum(num);
        chooseConversation(num);
    }

    const settopic = (num) => {
        document.querySelectorAll('.option').forEach(function(element) {
            element.style.border= '';
        })
        let element = document.getElementsByClassName('option')[num]
        element.style.border= '2px solid yellow';
        chooseTopic(num)
    }

    const chooseConversation = (conversationPlay) => {
        setDisplayStep1(false)
        let topics = [];
        switch(conversationPlay){
            case 0:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/color.png'),
                        text: "Color",
                        completed: freeplay.level3.favorite.color.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/animal.png'),
                        text: "Animal",
                        completed: freeplay.level3.favorite.animal.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/food.png'),
                        text: "Food",
                        completed: freeplay.level3.favorite.food.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/game.png'),
                        text: "Game",
                        completed: freeplay.level3.favorite.game.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/outside.png'),
                        text: "Thing to do outside",
                        completed: freeplay.level3.favorite.thing.unlocked

                    }
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/greet/greet_celebrate_record_awesome.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I am awesome!"')
                if (Object.values(freeplay.level3.favorite).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.favorite).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 1:
                topics = [
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Happy_resized.png"),
                        text: "Happy",
                        completed: freeplay.level3.feeling.happy.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Sad_resized.png"),
                        text: "Sad",
                        completed: freeplay.level3.feeling.sad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Calm_resized.png"),
                        text: "Calm",
                        completed: freeplay.level3.feeling.calm.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Mad_resized.png"),
                        text: "Mad",
                        completed: freeplay.level3.feeling.mad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Confident_resized.png"),
                        text: "Confident",
                        completed: freeplay.level3.feeling.confident.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Nervous_resized.png"),
                        text: "Nervous",
                        completed: freeplay.level3.feeling.nervous.unlocked

                    },
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/answer/answer_celebrate_record_amazing.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I am amazing!"')
                if (Object.values(freeplay.level3.feeling).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.feeling).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 2:
                topics = [
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Happy_resized.png"),
                        text: "Happy",
                        completed: freeplay.level3.listening.happy.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Sad_resized.png"),
                        text: "Sad",
                        completed: freeplay.level3.listening.sad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Calm_resized.png"),
                        text: "Calm",
                        completed: freeplay.level3.listening.calm.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Mad_resized.png"),
                        text: "Mad",
                        completed: freeplay.level3.listening.mad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Confident_resized.png"),
                        text: "Confident",
                        completed: freeplay.level3.listening.confident.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Nervous_resized.png"),
                        text: "Nervous",
                        completed: freeplay.level3.listening.nervous.unlocked

                    },
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/close/close_celebrate_record_believe.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I believe in me!"')
                if (Object.values(freeplay.level3.listening).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.listening).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 3:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/favorite_subject.png'),
                        text: "Favorite subject in school",
                        completed: freeplay.level3.friends.subject.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/outside.png'),
                        text: "Outside",
                        completed: freeplay.level3.friends.outside.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/animal.png'),
                        text: "Animal",
                        completed: freeplay.level3.friends.animal.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/food.png'),
                        text: "Food",
                        completed: freeplay.level3.friends.food.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/favorite_fun.png'),
                        text: "What you like to do for fun",
                        completed: freeplay.level3.friends.fun.unlocked

                    },
                ];
                setTopics(topics);
                if (Object.values(freeplay.level3.friends).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.friends).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 4:
                topics = [
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Sad_resized.png"),
                        text: "Sad",
                        completed: freeplay.level3.solution.sad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Mad_resized.png"),
                        text: "Mad",
                        completed: freeplay.level3.solution.mad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Nervous_resized.png"),
                        text: "Nervous",
                        completed: freeplay.level3.solution.nervous.unlocked

                    },
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/respond/respond_celebrate_record_do_all.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I can do it all!"')
                if (Object.values(freeplay.level3.solution).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.solution).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 5:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/seat_taken.png'),
                        text: "Seat Taken",
                        completed: freeplay.level3.conflict.seat.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/dino_toy.png'),
                        text: "Dislike Toy",
                        completed: freeplay.level3.conflict.shop.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/shovel.png'),
                        text: "Stole Shovel",
                        completed: freeplay.level3.conflict.shovel.unlocked

                    },
                    {
                        img: generateImageUrl('images/Module8Images/Module8NavImages/JourneyMap_Mod3_Day8.png'),
                        text: "Blocking View",
                        completed: freeplay.level3.conflict.stand.unlocked

                    },
                    {
                        img: generateImageUrl('images/Module4Images/Reward_Camera.png'),
                        text: "Bumped Into",
                        completed: freeplay.level3.conflict.photo.unlocked

                    },
                ];
                setTopics(topics);
                if (Object.values(freeplay.level3.conflict).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.conflict).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 6:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/feed_birds.png'),
                        text: "Feed the Birds",
                        completed: freeplay.level3.advocacy.bird.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/buy_tickets.png'),
                        text: "Buy a Ticket",
                        completed: freeplay.level3.advocacy.train.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/ask_monkey.png'),
                        text: "Ask a Question",
                        completed: freeplay.level3.advocacy.monkey.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/teacher.jpg'),
                        text: "Ask for Teacher",
                        completed: freeplay.level3.advocacy.care.unlocked 

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/ask_napkin.png'),
                        text: "Ask for Napkin",
                        completed: freeplay.level3.advocacy.snack.unlocked

                    }
                ];
                setTopics(topics);
                if (Object.values(freeplay.level3.advocacy).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.advocacy).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 7:
                // Objects to be pushed into the array
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/snow_cone.png'),
                        text: "Snow Cone Stand",
                        completed: freeplay.level3.community.cone.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/beach_topics.png'),
                        text: "Beach",
                        completed: freeplay.level3.community.guard.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/theme_park_topic.png'),
                        text: "Theme Park",
                        completed: freeplay.level3.community.wheel.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/arcade_topic.png'),
                        text: "Arcade",
                        completed: freeplay.level3.community.arcade.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/fast_food_topic.png'),
                        text: "Fast Food",
                        completed: freeplay.level3.community.food.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/saloon_topic.png'),
                        text: "Salon",
                        completed: freeplay.level3.community.salon.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/clothing_topic.png'),
                        text: "Clothing Store",
                        completed: freeplay.level3.community.clothing.unlocked
                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/bakery_topic.png'),
                        text: "Bakery",
                        completed: freeplay.level3.community.bakery.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/groceries_topic.png'),
                        text: "Grocery Store",
                        completed: freeplay.level3.community.grocery.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/cinema_topic.png'),
                        text: "Movie Theater",
                        completed: freeplay.level3.community.theater.unlocked

                    },
                ];
                setTopics(topics);
                if (Object.values(freeplay.level3.community).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.community).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            default:
                break;
        }
        setDisplayStep2(true)
        // setDisplayGame(true)
    }

    const chooseTopic = (topicPlay) => {
        setDisplayStep2(false);
        let stepPrompts = [];
        let turns = [];
        let instructions = [];
        let texts = [];
        let exampleVideos = [];
        let codes = [];
        let celebrateAudios = [];
        let celebrateTexts = [];
        let topicNames = [];
        switch(conversationNum){
            case 0:
                turns = [
                    'Your Friend’s Turn',
                    'Your Turn',
                    'Your Friend’s Turn',
                    'Your Turn',
                    'Your Friend’s Turn',   
                    'Your Turn',
                    'Your Friend’s Turn',
                    'Your Turn',
                    'Your Friend’s Turn',
                    'Your Turn',
                ]
                texts = [
                    [
                        'Say, "Hi!"',
                        'Greet your friend.',
                        'Say, “What is your favorite color?”',
                        'Say your favorite color.',
                        'Say, “Cool!”',
                        'Ask your friend their favorite color.',
                        'Say, "My favorite color is ______."',
                        'Respond to your friend’s answer.',
                        'Press record and say, "Goodbye!"',
                        'Close the conversation with your friend.'
                    ],
                    [
                        'Say, "Hi!"',
                        'Greet your friend.',
                        'Say, "What is your favorite animal?"',
                        'Say your favorite animal.',
                        'Say, "Cool!"',
                        'Ask your friend their favorite animal.',
                        'Say, "My favorite animal is ______."',
                        'Respond to your friend’s answer.',
                        'Say, "Goodbye!"',
                        'Close the conversation with your friend.'
                      ],
                      [
                        'Say, "Hi!"',
                        'Greet your friend.',
                        'Say, "What is your favorite food?"',
                        'Say your favorite food.',
                        'Say, "Cool!"',
                        'Ask your friend their favorite food.',
                        'Say, "My favorite food is ______."',
                        'Respond to your friend’s answer.',
                        'Say, "Goodbye!"',
                        'Close the conversation with your friend.'
                      ],
                      [
                        'Say, "Hi!"',
                        'Greet your friend.',
                        'Say, "What is your favorite game?"',
                        'Say your favorite game.',
                        'Say, "Cool!"',
                        'Ask your friend their favorite game.',
                        'Say, "My favorite game is ______."',
                        'Respond to your friend’s answer.',
                        'Say, "Goodbye!"',
                        'Close the conversation with your friend.'
                      ],
                      [
                        'Say, "Hi!"',
                        'Greet your friend.',
                        'Say, "What is your favorite thing to do outside?"',
                        'Say your favorite thing to do outside.',
                        'Say, "Cool!"',
                        'Ask your friend their favorite thing to do outside.',
                        'Say, "My favorite thing to do outside is ______."',
                        'Respond to your friend’s answer.',
                        'Say, "Goodbye!"',
                        'Close the conversation with your friend.'
                      ]
                ];
                exampleVideos = [
                    'appfiles/freeplay/favorite/demo_color.mp4',
                    'appfiles/freeplay/favorite/demo_animal.mp4',
                    'appfiles/freeplay/favorite/demo_food.mp4',
                    'appfiles/freeplay/favorite/demo_game.mp4',
                    'appfiles/freeplay/favorite/demo_outside.mp4',
                ];
                topicNames = [
                    'Color',
                    'Animal',
                    'Food',
                    'Game',
                    'Thing to do outside',
                ];
                codes = [
                    'COLOR',
                    'ANIMAL',
                    'FOOD',
                    'GAME',
                    'THING',
                ];
                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Did you greet your friend? (hi, hello, it is good to see you, etc.)", 
                    "Did you answer your friend’s question?", 
                    "Did you ask your friend a question?", 
                    "Did you respond to your friend’s answer? (that is great, cool, nice, etc.)",
                    "Did you close the conversation with your friend? (goodbye, bye, see you later, etc.)",
                ]);
                setPractice(
                    <Friends
                      selectedStudentCharacter={selectedStudentCharacter}
                      selectedFriendCharacter={selectedFriendCharacter}
                      setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                      background={backgrounds[bgIdx]}
                      turns={turns}
                      texts={texts[topicPlay]}
                      influencerid={influencers[topicPlay]}
                      exampleVideo={getVideo(exampleVideos[topicPlay], login)}
                      practiceConversation={getVideo('appfiles/greet/practice_watch_conversation.gif', login)}
                      practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                      awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                      practiceConversationAudio={'appfiles/freeplay/practice_watch_conversation.mp3'}
                      practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                      awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                      finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                      level={"LEVEL3"}
                      conversation={'FAVORITE'}
                      title={"Favorite Things"}
                      subTitle={topicNames[topicPlay]}
                      topic={codes[topicPlay]}      
                    />
                  );
                setTopicName(`FAVORITE_${codes[topicPlay]}`)
                break;
            case 1:
                turns = [
                    [
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn'
                    ],
                    [
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn'
                    ],
                    [
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn'
                    ],
                    [
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn'
                    ],
                    [
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn'
                    ],
                    [
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn'
                    ]
                ]

                texts = [
                    [
                        'Ask, "What makes you feel happy?"',
                        'Say, "I feel _____ when ________."',
                        'Say, "I’m glad that makes you feel happy!"',
                        'Say, "Thank you."',
                    ],
                    [
                        'Ask, "What makes you feel sad?"',
                        'Say, "I feel _____ when ________."',
                        'Say, "I’m sorry that makes you feel sad."',
                        'Say, "Thank you."'
                    ],
                    [
                        'Ask, "What makes you feel calm?"',
                        'Say, "I feel _____ when ________."',
                        'Say, "I’m glad that makes you feel calm."',
                        'Say, "Thank you."'
                    ],
                    [
                        'Ask, "What makes you feel mad?"',
                        'Say, "I feel _____ when ________."',
                        'Say, "I’m sorry that makes you feel mad."',
                        'Say, "Thank you."'
                    ],
                    [
                        'Ask, "What makes you feel confident?"',
                        'Say, "I feel _____ when ________."',
                        'Say, "I’m glad that makes you feel confident!"',
                        'Say, "Thank you."'
                    ],
                    [
                        'Ask, "What makes you feel nervous?"',
                        'Say, "I feel _____ when ________."',
                        'Say, "I’m sorry that makes you feel nervous."',
                        'Say, "Thank you."'
                    ],
                ];
                exampleVideos = [
                    'appfiles/freeplay/feeling/demo_happy.mp4',
                    'appfiles/freeplay/feeling/demo_sad.mp4',
                    'appfiles/freeplay/feeling/demo_calm.mp4',
                    'appfiles/freeplay/feeling/demo_mad.mp4',
                    'appfiles/freeplay/feeling/demo_confident.mp4',
                    'appfiles/freeplay/feeling/demo_nervous.mp4',
                ];
                topicNames = [
                    'Happy',
                    'Sad',
                    'Calm',
                    'Mad',
                    'Confident',
                    'Nervous',
                ];
                codes = [
                    'HAPPY',
                    'SAD',
                    'CALM',
                    'MAD',
                    'CONFIDENT',
                    'NERVOUS'
                ];
                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Did you tell your friend how you feel and why? (For example: I feel_____when_____.)"
                ]);
                setPractice(
                    <Friends
                      selectedStudentCharacter={selectedStudentCharacter}
                      selectedFriendCharacter={selectedFriendCharacter}
                      setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                      background={backgrounds[bgIdx]}
                      turns={turns[topicPlay]}
                      texts={texts[topicPlay]}
                      influencerid={influencers[topicPlay]}
                      exampleVideo={getVideo(exampleVideos[topicPlay], login)}
                      practiceConversation={getVideo('appfiles/greet/practice_watch_conversation.gif', login)}
                      practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                      awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                      practiceConversationAudio={'appfiles/freeplay/practice_watch_conversation.mp3'}
                      practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                      awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                      finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                      level={"LEVEL3"}
                      conversation={'FEELING'}
                      title={"Talk about Feelings"}
                      subTitle={topicNames[topicPlay]}
                      topic={codes[topicPlay]}
                    />
                  );
                setTopicName(`FEELING_${codes[topicPlay]}`)
                break;
            case 2:
                turns = [
                    [
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn'
                    ],
                    [
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn'
                    ],
                    [
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn'
                    ],
                    [
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn'
                    ],
                    [
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn'
                    ],
                    [
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn'
                    ]
                ]
                texts = [
                    [
                      // Happy
                      'Ask, "What makes you feel happy?"',
                      'Say, "I feel ______ when ______."',
                      'Say, "I am ______ that makes you feel ______!"',
                      'Say, "Thank you."',
                    ],
                    [
                      // Sad
                      'Ask, "What makes you feel sad?"',
                      'Say, "I feel ______ when ______."',
                      'Say, "I am ______ that makes you feel ______."',
                      'Say, "Thank you."',
                    ],
                    [
                      // Calm
                      'Ask, "What makes you feel calm?"',
                      'Say, "I feel ______ when ______."',
                      'Say, "I am ______ that makes you feel ______."',
                      'Say, "Thank you."',
                    ],
                    [
                      // Mad
                      'Ask, "What makes you feel mad?"',
                      'Say, "I feel ______ when ______."',
                      'Say, "I am ______ that makes you feel ______."',
                      'Say, "Thank you."',
                    ],
                    [
                        // Confident
                        'Ask, "What makes you feel confident?"',
                        'Say, "I feel ______ when ______."',
                        'Say, "I am ______ that makes you feel ______."',
                        'Say, "Thank you."'
                    ],
                    [
                      // Nervous
                      'Ask, "What makes you feel nervous?"',
                      'Say, "I feel ______ when ______."',
                      'Say, "I am ______ that makes you feel ______."',
                      'Say, "Thank you."',
                    ],
                ]
                exampleVideos = [
                    'appfiles/freeplay/listening/demo_happy.mp4',
                    'appfiles/freeplay/listening/demo_sad.mp4',
                    'appfiles/freeplay/listening/demo_calm.mp4',
                    'appfiles/freeplay/listening/demo_mad.mp4',
                    'appfiles/freeplay/listening/demo_confident.mp4',
                    'appfiles/freeplay/listening/demo_nervous.mp4',
                ];
                topicNames = [
                    'Happy',
                    'Sad',
                    'Calm',
                    'Mad',
                    'Confident',
                    'Nervous',
                ];
                codes = [
                    'HAPPY',
                    'SAD',
                    'CALM',
                    'MAD',
                    'CONFIDENT',
                    'NERVOUS'
                ];
                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Did you respond to your friend as an active listener? (For example: I am ______ that makes you feel ______.)"
                ]);
                setPractice(
                    <Friends
                      selectedStudentCharacter={selectedStudentCharacter}
                      selectedFriendCharacter={selectedFriendCharacter}
                      setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                      background={backgrounds[bgIdx]}
                      turns={turns[topicPlay]}
                      texts={texts[topicPlay]}
                      influencerid={influencers[topicPlay]}
                      exampleVideo={getVideo(exampleVideos[topicPlay], login)}
                      practiceConversation={getVideo('appfiles/manners/manners_let_watch.gif', login)}
                      practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                      awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                      practiceConversationAudio={'appfiles/freeplay/practice_watch_conversation.mp3'}
                      practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                      awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                      finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                      level={"LEVEL3"}
                      conversation={'LISTENING'}
                      title={"Active Listening"}
                      subTitle={topicNames[topicPlay]}
                      topic={codes[topicPlay]}
                    />
                  );
                setTopicName(`LISTENING_${codes[topicPlay]}`)
                break;
            case 3:
                stepPrompts = [
                    'Step 1: Be Kind',
                    'Step 1: Be Kind',
                    'Step 2: Ask Questions',
                    'Step 2: Ask Questions',
                    'Step 2: Ask Questions',
                    'Step 2: Ask Questions',
                    'Step 2: Ask Questions',
                    'Step 2: Ask Questions',
                ]
                turns = [
                    'Your Turn','Your Friend’s Turn','Your Turn','Your Friend’s Turn','Your Turn',
                    'Your Friend’s Turn','Your Turn','Your Friend’s Turn','Your Turn','Your Friend’s Turn'
                ]
              
                texts = [
                    // Subject
                    [
                        'Greet your friend and ask their name.',
                        'Say, "Hello! My name is ______."',
                        'Ask your friend their favorite subject in school.',
                        'Say, "My favorite subject in school is ______."',
                        'Respond to your friend’s answer.',
                        'Ask, "What is your favorite subject in school?"',
                        'Say, "My favorite subject in school is ______."',
                        'Say, "Cool!"',
                        'Close the conversation with your friend.',
                        'Say, "Goodbye!"'
                    ],
                    // Outside
                    [
                        'Greet your friend and ask their name.',
                        'Say, "Hello! My name is ______."',
                        'Ask your friend their favorite thing to do outside.',
                        'Say, "My favorite thing to do outside is ______."',
                        'Respond to your friend’s answer.',
                        'Ask, "What is your favorite thing to do outside?"',
                        'Say, "My favorite thing to do outside is ______."',
                        'Say, "Cool!"',
                        'Close the conversation with your friend.',
                        'Say, "Goodbye!"'
                    ],
                    // Animal
                    [
                        'Greet your friend and ask their name.',
                        'Say, "Hello! My name is ______."',
                        'Ask your friend their favorite animal.',
                        'Say, "My favorite animal is ______."',
                        'Respond to your friend’s answer.',
                        'Ask, "What is your favorite animal?"',
                        'Say, "My favorite animal is ______."',
                        'Say, "Cool!"',
                        'Close the conversation with your friend.',
                        'Say, "Goodbye!"'
                    ],
                    // Food
                    [
                        'Greet your friend and ask their name.',
                        'Say, "Hello! My name is ______."',
                        'Ask your friend their favorite food.',
                        'Say, "My favorite food is ______."',
                        'Respond to your friend’s answer.',
                        'Ask, "What is your favorite food?"',
                        'Say, "My favorite food is ______."',
                        'Say, "Cool!"',
                        'Close the conversation with your friend.',
                        'Say, "Goodbye!"'
                    ],
                    // Fun
                    [
                        'Greet your friend and ask their name.',
                        'Say, "Hello! My name is ______."',
                        'Ask your friend what they like to do for fun.',
                        'Say, "My favorite thing to do for fun is ______."',
                        'Respond to your friend’s answer.',
                        'Ask, "What is your favorite thing to do for fun?"',
                        'Say, "My favorite thing to do for fun is ______."',
                        'Say, "Cool!"',
                        'Close the conversation with your friend.',
                        'Say, "Goodbye!"'
                    ]
                ]
                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Step 1: Be Kind. Did you greet your friend and ask their name in a kind way?",
                    "Step 2: Ask Questions. Did you ask your friend a question to get to know them?"
                ]);
                exampleVideos = [
                    'e294350f0903d692904e2d120bd2/480.m3u8',
                    '20e09d03369321476cb731f8bc8e/360.m3u8',
                    'abb95df072889cc1482d42c212fa/480.m3u8',
                    '0a653ee421546c268cd682d894f9/480.m3u8',
                    'bc6f2aaa640b56c6ca88d64e2718/480.m3u8',
                ];
                topicNames = [
                    'Favorite Subject in School',
                    'Outside',
                    'Animal',
                    'Food',
                    'What you like to do for fun',
                ];
                codes = [
                    'SUBJECT',
                    'OUTSIDE',
                    'ANIMAL',
                    'FOOD',
                    'FUN',
                ];
                celebrateAudios = ['appfiles/friends_bullying/friends_bullying_celebrate_record_kind.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_questions.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_not_bully.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_stop_bullying.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_making_friends.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I am amazing because I am kind!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I ask good questions!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I do not bully others!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I tell others to stop bullying!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I am good at making friends!"`]
                setPractice(
                    <Friends
                      selectedStudentCharacter={selectedStudentCharacter}
                      selectedFriendCharacter={selectedFriendCharacter}
                      setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                      background={backgrounds[bgIdx]}
                      stepPrompts={stepPrompts}
                      turns={turns}
                      texts={texts[topicPlay]}
                      influencerid={influencers[topicPlay]}
                      practiceConversation={getVideo('appfiles/manners/manners_let_watch.gif', login)}
                      practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                      awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                      practiceConversationAudio={'appfiles/freeplay/practice_watch_conversation.mp3'}
                      practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                      awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                      exampleVideo={exampleVideos[topicPlay]}
                      finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                      level={"LEVEL3"}
                      conversation={'FRIENDS'}
                      topic={codes[topicPlay]}
                      title={"Making Friends"}  
                      subTitle={topicNames[topicPlay]}
                    />
                );
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                setTopicName(`FRIENDS_${codes[topicPlay]}`)
                break;
            case 4:
                turns = [
                    'Your Friend’s Turn',
                    'Your Turn',
                    'Your Friend’s Turn',
                    'Your Turn',
                    'Your Friend’s Turn',
                ]
                    
                texts = [
                    // Sad
                    [
                        'Ask, "What makes you feel sad?"',
                        'Say, "I feel ______ when ______."',
                        'Say, "I’m sorry that makes you feel sad. What is a solution?"',
                        'Say, "I will ______."',
                        'Say, "Great solution!"'
                    ],
                    // Mad
                    [
                        'Ask, "What makes you feel mad?"',
                        'Say, "I feel ______ when ______."',
                        'Say, "I’m sorry that makes you feel mad. What is a solution?"',
                        'Say, "I will ______."',
                        'Say, "Great solution!"'
                    ],
                    // Nervous
                    [
                        'Ask, "What makes you feel nervous?"',
                        'Say, "I feel ______ when ______."',
                        'Say, "I’m sorry that makes you feel nervous. What is a solution?"',
                        'Say, "I will ______."',
                        'Say, "Great solution!"'
                    ]
                ]
                exampleVideos = [
                    'appfiles/freeplay/solution/demo_sad.mp4',
                    'appfiles/freeplay/solution/demo_mad.mp4',
                    'appfiles/freeplay/solution/demo_nervous.mp4',
                ];
                topicNames = [
                    'Sad',
                    'Mad',
                    'Nervous',
                ];
                codes = [
                    'SAD',
                    'MAD',
                    'NERVOUS'
                ];
                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Did you tell your friend how you feel and why? (For example: I feel ______ when ______.)",
                    "Did you come up with a fair solution to change your feelings?"
                ]);
                setPractice(
                    <Friends
                    selectedStudentCharacter={selectedStudentCharacter}
                    selectedFriendCharacter={selectedFriendCharacter}
                    turns={turns}
                    setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                    background={backgrounds[bgIdx]}
                    texts={texts[topicPlay]}
                    influencerid={influencers[topicPlay]}
                    exampleVideo={getVideo(exampleVideos[topicPlay], login)}
                    practiceConversation={getVideo('appfiles/greet/practice_watch_conversation.gif', login)}
                    practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                    awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                    practiceConversationAudio={'appfiles/freeplay/practice_watch_conversation.mp3'}
                    practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                    awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                    finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                    level={"LEVEL3"}
                    conversation={'SOLUTION'}
                    title={"Solutions"}
                    subTitle={topicNames[topicPlay]}
                    topic={codes[topicPlay]}
                    />
                );
                setTopicName(`SOLUTION_${codes[topicPlay]}`)
                break;    
            case 5:
                turns = [
                    [   
                        'Your Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn'
                    ],
                    [   
                        'Your Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn'
                    ],
                    [   
                        'Your Turn',
                        'Your Friend’s Turn',   
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn'
                    ],
                    [   
                        'Your Turn',
                        'Your Friend’s Turn',   
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn'
                    ],
                    [   
                        'Your Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn'
                    ]
                ]
                    
                texts = [
                    // 1) Bus seat
                    [
                        'Take a deep breath.',
                        'Say, "I feel ______ because I want to sit where you are sitting."',
                        'Say, "I am sorry you feel ______ that you want to sit here. I was sitting here first."',
                        'Say, "I am sorry that I ______."',
                        'Say, "It is okay, we can share the seat."',
                        'Say how you can make it better next time you are on the bus.',
                    ],
                    
                    // 2) Toy preference
                    [
                        'Take a deep breath.',
                        'Say, "I feel ______ you do not like my toy. Can you tell me why?"',
                        'Say, "I am sorry I made you feel sad because I said I didn’t like your toy. I didn’t mean to be rude, but I’ve never played with that toy before."',
                        'Say, "Thanks. It is okay to like different things."',
                        'Say, "And I need to learn to play with different toys."',
                        'Say how you can make it better next time.',
                    ],
                    
                    // 3) Shovel
                    [
                        'Take a deep breath.',
                        'Say, "Hi! What is wrong?"',
                        'Say, "I feel ______ because you took my shovel. Can you tell me why?"',
                        'Say, "I am sorry I took your shovel. I didn’t know you were still using it."',
                        'Say, "I’m sorry I got mad that you took the shovel. Do you want to share it with me?"',
                        'Say, "Yes, and next time I will ask before taking the shovel."',
                        'Say how you can make it better next time.',
                    ],
                    
                    // 4) Dinosaur view
                    [
                        'Take a deep breath.',
                        'Say, "Excuse me, I cannot see the dinosaur."',
                        'Say, "I am sorry. I did not see you standing there."',
                        'Say, "It is okay. I should not get so mad."',
                        'Say, "I can move over so you can see the dinosaur too."',
                        'Say, "Sure, thanks!"',
                        'Say how you can make it better next time.',
                    ],
                    
                    // 5) Picture bump
                    [
                        'Take a deep breath.',
                        'Say, "Please be more careful, I am trying to take a picture."',
                        'Say, "Oh, I am so sorry. I tripped and bumped into you."',
                        'Say, "It is okay."',
                        'Say, "Thanks. Next time I’ll try to be more careful."',
                        'Say how you can make it better next time.',
                    ],
                ]

                stepPrompts = [
                    'Step 1: Be Calm',
                    'Step 2: Talk About It',
                    'Step 2: Talk About It',
                    'Step 3: Make It Better',
                    'Step 3: Make It Better',
                    'Step 3: Make It Better'
                ]

                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Step 1: Be Calm. Did you calm down by taking a deep breath?",
                    "Step 2: Talk About It. Did you say how you feel and why?",
                    "Step 3: Make It Better. Did you and your friend come up with a solution?"
                ]);
                
                exampleVideos = [
                    '404cb8c87ea68b34d68800759f38/480.m3u8',
                    'fdddc64c4ad070485f1c4acc2d2b/480.m3u8',
                    '1ff916c5d26e53fbe959c4cca11e/480.m3u8',
                    '18146ebf75b03a8d7c401bc13231/480.m3u8',
                    '04f9df0feca686e42f2da64e25ba/480.m3u8',
                ];

                topicNames = [
                    'Seat Taken',
                    'Dislike Toy',
                    'Stole Shovel',
                    'Blocking View',
                    'Bumped Into',
                ];
                
                codes = [
                    'SEAT',
                    'SHOP',
                    'SHOVEL',
                    'STAND',
                    'PHOTO',
                ];
                celebrateAudios = ['appfiles/resolve_conflict/resolve_conflict_celebrate_calm.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_feelings.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_listener.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_solve_problems.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_better.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I am a very important person because I know when to be calm!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I can talk about my feelings!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I am a good listener!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I solve problems with friends!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I can make things better!"`]
                setPractice(
                    <Friends
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                        background={backgrounds[bgIdx]}
                        instructions={instructions[topicPlay]}
                        stepPrompts={stepPrompts}
                        turns={turns[topicPlay]}
                        texts={texts[topicPlay]}
                        influencerid={influencers[topicPlay]}
                        practiceConversation={getVideo('appfiles/manners/manners_let_watch.gif', login)}
                        practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                        awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                        practiceConversationAudio={'appfiles/freeplay/practice_watch_conversation.mp3'}
                        practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                        awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                        exampleVideo={exampleVideos[topicPlay]}
                        finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                        level={"LEVEL3"}
                        conversation={'CONFLICT'}
                        topic={codes[topicPlay]}
                        title={"Resolve Conflict"}
                        subTitle={topicNames[topicPlay]}
                    />
                );
                setTopicName(`CONFLICT_${codes[topicPlay]}`)
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                break;
            case 6:
                stepPrompts = [
                    'Step 1: Think About What You Want to Say',
                    'Step 2: Believe in Yourself',
                    'Step 3: Achieve It!',
                    'Step 3: Achieve It!',
                    'Step 3: Achieve It!',
                    'Step 3: Achieve It!',
                    'Step 3: Achieve It!',
                ]

                turns = [
                      'Your Turn',
                      'You and Your Friend Together',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                ]
                  
                texts = [
                    // 1) Feed the birds
                    [
                      'Think about saying, "Hi! Can I feed the birds, please?"',
                      'Sing the Joyful Jingle',
                      'Say, "Hello! I am a bird trainer. How can I help you?"',
                      'Greet the bird trainer and ask if you can feed the birds.',
                      'Say, "Yes, you can feed the birds. Thank you for asking. You are using good manners."',
                      'Respond to the bird trainer and close the conversation.',
                      'Say, "Bye!"'
                    ],
                  
                    // 2) Buy a train ticket
                    [
                      'Think about saying, "Hi! Can you please tell me where I can buy a train ticket?"',
                      'Sing the Joyful Jingle',
                      'Say, "Hi! My name is ______ and I am a train conductor. How can I help you?"',
                      'Say, "Hi! Can you please tell me where I can buy a train ticket?"',
                      'Say, "Yes, you can buy a ticket around the corner at the window. Thanks for using good manners."',
                      'Respond to the train conductor and close the conversation.',
                      'Say, "Bye!"'
                    ],
                  
                    // 3) Ask about monkeys
                    [
                      'Think about saying, "Hi! What do monkeys like to eat?"',
                      'Sing the Joyful Jingle',
                      'Say, "Hi! I am a monkey trainer. How can I help you?"',
                      'Say, "Hi! What do monkeys like to eat?"',
                      'Say, "Monkeys like to eat lots of foods such as seeds and fruits. Thank you for asking a great question."',
                      'Respond to the monkey trainer and close the conversation.',
                      'Say, "Bye!"'
                    ],

                    // 5) Find my teacher (reptile worker)
                    [
                        'Think about saying, "Hi! Can you help me find my teacher?"',
                        'Sing the Joyful Jingle',
                        'Say, "Hi! I work with reptiles. How may I help you?"',
                        'Say, "Hi! Can you help me find my teacher?"',
                        'Say, "Yes, of course. I will call for help and have your teacher meet us here."',
                        'Respond to the worker and close the conversation.',
                        'Say, "Bye!"'
                    ],
                  
                    // 4) Get a napkin at the Snack Shack
                    [
                      'Think about saying, "Hi! Can I get a napkin, please?"',
                      'Sing the Joyful Jingle',
                      'Say, "Hi! I work at the Snack Shack. How can I help you?"',
                      'Say, "Hi! Can I get a napkin, please?"',
                      'Say, "Of course, the napkins are right by the drinks."',
                      'Respond to the worker and close the conversation.',
                      'Say, "Bye!"'
                    ],
                ]

                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Step 1: Think About What You Want to Say. Did you think about what you want to say?",
                    "Step 2: Believe in Yourself. Did you sing the Joyful Jingle?",
                    "Step 3: Achieve It. Did you greet your friend and ask them a question?",
                ]);
                  
                exampleVideos = [
                    'f06b82cae82f3db9ed5f8f897105/480.m3u8',
                    '9550b4175a782c9389044a6ec646/360.m3u8',
                    'c5d12c682e57d21a4af35c6b9f72/480.m3u8',
                    'ca7ad958f25622f7befcd5a1cc35/360.m3u8',
                    '73a5fde4b0fe966c33648df9d5f2/480.m3u8',
                ];
                
                codes = [
                    'BIRD',
                    'TRAIN',
                    'MONKEY',
                    'CARE',
                    'SNACK',
                ];
                topicNames = [
                    'Feed the Birds',
                    'Buy a Ticket',
                    'Ask a Question',
                    'Ask for Teacher',
                    'Ask for Napkin',
                ];
                celebrateAudios = ['appfiles/self_advocacy/self_advocacy_celebrate_record_think.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_believe.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_achieve.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_speak_up.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_stand_up.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I can do it all, because I think about what I want to say or do!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I believe in myself!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I achieve great things!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I can speak up for myself!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I can stand up for myself!"`]
                setPractice(
                    <Friends
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                        background={backgrounds[bgIdx]}
                        stepPrompts={stepPrompts}
                        turns={turns}
                        texts={texts[topicPlay]}
                        influencerid={influencers[topicPlay]}
                        practiceConversation={getVideo('appfiles/manners/manners_let_watch.gif', login)}
                        practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                        awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                        practiceConversationAudio={'appfiles/freeplay/practice_watch_conversation.mp3'}
                        practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                        awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                        exampleVideo={exampleVideos[topicPlay]}
                        finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                        level={"LEVEL3"}
                        conversation={'ADVOCACY'}
                        topic={codes[topicPlay]}
                        title={"Self-Advocacy"}
                        subTitle={topicNames[topicPlay]}
                    />
                );
                setTopicName(`ADVOCACY_${codes[topicPlay]}`)
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                break;
            case 7:
                turns = [
                    // 2) Snow cone maker
                    [
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                    ],

                    // 1) Lifeguard
                    [
                      'Your Friend’s Turn', // Greet
                      'Your Turn',          // Greet
                      'Your Friend’s Turn', // Ask
                      'Your Turn',          // Answer
                      'Your Friend’s Turn', // Respond
                      'Your Turn',          // Close
                      'Your Friend’s Turn', // Close
                    ],
                  
                    // 3) Ferris wheel tickets
                    [
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                    ],
                  
                    // 4) Arcade
                    [
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                    ],
                  
                    // 5) Fast food worker
                    [
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                    ],
                  
                    // 6) Hair stylist
                    [
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                    ],
                  
                    // 7) Clothing store
                    [
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                    ],
                  
                    // 8) Bakery
                    [
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                    ],

                    // 10) Grocery store
                    [
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                        'Your Turn',
                        'Your Friend’s Turn',
                    ],
                  
                    // 9) Movie theater
                    [
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                      'Your Turn',
                      'Your Friend’s Turn',
                    ],
                  
                ]
                  
                texts = [
                // 2) Snow cone maker
                    [
                        'Say, "Hi! My name is ______. My job is to make snow cones."',
                        'Greet the snow cone worker.',
                        'Ask, "What is your favorite snow cone flavor?"',
                        'Say, "My favorite flavor is ______."',
                        'Say, "Yum! That’s a great choice!"',
                        'Close the conversation.',
                        'Say, "Bye."'
                    ],
                                        
                    // 1) Lifeguard
                    [
                      'Say, "Hi! My name is ______ and I am a lifeguard. I am here to help keep people safe."',
                      'Greet the lifeguard.',
                      'Ask, "What is your favorite thing to do at the beach?"',
                      'Say, "I like to ______."',
                      'Say, "That is great!"',
                      'Close the conversation.',
                      'Say, "Bye."'
                    ],
                  
                    // 3) Ferris wheel tickets
                    [
                      'Say, "Hi! I take tickets from people to ride the ferris wheel."',
                      'Greet the ticket taker.',
                      'Ask, "Would you like the ferris wheel to go fast or slow?"',
                      'Say, "I would like the ferris wheel to go ______."',
                      'Say, "Great! Have fun!"',
                      'Close the conversation.',
                      'Say, "Bye."'
                    ],
                  
                    // 4) Arcade
                    [
                      'Say, "Hi! My name is ______ and I work at the arcade."',
                      'Greet the arcade worker.',
                      'Ask, "What is your favorite game?"',
                      'Say, "My favorite game is ______."',
                      'Say, "Nice! That’s a fun game."',
                      'Close the conversation.',
                      'Say, "Bye."'
                    ],
                  
                    // 5) Fast food worker
                    [
                      'Say, "Hi! My name is ______ and I am a fast food worker."',
                      'Greet the fast food worker.',
                      'Ask, "If you were to order fast food, would you order a hamburger, chicken nuggets, or something else?"',
                      'Say, "I would order ______."',
                      'Say, "Great choice!"',
                      'Close the conversation.',
                      'Say, "Bye."'
                    ],
                  
                    // 6) Hair stylist
                    [
                      'Say, "Hi! I love to cut hair to make people look great."',
                      'Greet the hair stylist.',
                      'Ask, "What do you think of my work?"',
                      'Give a compliment.',
                      'Say, "Thank you!"',
                      'Close the conversation.',
                      'Say, "Bye."'
                    ],
                  
                    // 7) Clothing store
                    [
                      'Say, "Hi! I work at a clothing store."',
                      'Greet the store worker.',
                      'Ask, "Can I help you find something?"',
                      'Say, "Can you please help me find the ______?"',
                      'Say, "Of course! It’s over here."',
                      'Close the conversation.',
                      'Say, "Bye."'
                    ],
                  
                    // 8) Bakery
                    [
                      'Say, "Hi! My name is ______ and I work at the bakery."',
                      'Greet the bakery worker.',
                      'Ask, "I love to bake cupcakes. What is your favorite flavor?"',
                      'Say, "My favorite flavor is ______."',
                      'Say, "Yum! Great choice."',
                      'Close the conversation.',
                      'Say, "Bye."'
                    ],

                    // 10) Grocery store
                    [
                        'Say, "Hi! My name is ______ and I work at a grocery store. How are you today?"',
                        'Greet and respond.',
                        'Ask, "Wonderful! What are you here to buy?"',
                        'Say, "I am here to buy ______."',
                        'Say, "That will be ______."',
                        'Close the conversation.',
                        'Say, "Bye."'
                    ],
                  
                    // 9) Movie theater
                    [
                      'Say, "Hi! I work at the movie theater. How are you today?"',
                      'Greet and respond.',
                      'Ask, "It is my job to look at movie tickets. Can I see your movie ticket?"',
                      'Say, "Here you go."',
                      'Say, "Thank you. I love that movie. It’s the first movie theater on the right."',
                      'Close the conversation.',
                      'Say, "Bye."'
                    ],
                ]

                setValuationQuestions([
                    "Step 1: How I act. Did you use the 5 foundational skills (eye contact, listening, smile, posture, distance)?", 
                    "Step 2: What I say: Did you use kind words?",
                    "Step 3: How I saw it: Did you talk in a calm voice?",
                    "Did you greet your friend?",
                    "Did you answer your friend’s question?",
                    "Did you close the conversation?"
                ]);

                exampleVideos = [
                    '3fdbbcc43c87c92ae2d9a8b58e1a/480.m3u8',
                    'a206033e9e68ceebfd64f6f631a3/480.m3u8',
                    'a5c56f28753f1a2e91c91a373e94/480.m3u8',
                    '7a77d2fbfa33ac22810725c228a4/480.m3u8',
                    'b06fdefc2247638b56e9bf9cde38/480.m3u8',
                    'f8e52e21ea4561a78d5c38967804/480.m3u8',
                    'debc60bcaf698b2ac158fd60ca8b/480.m3u8',
                    'Module20/day4_practice_conversation.mp4',
                    '4b742312947d83473d21f6888019/480.m3u8',
                    'Module20/day8_practice_conversation.mp4',
                ];
                codes = [
                    'CONE',
                    'GUARD',
                    'WHEEL',
                    'ARCADE',
                    'FOOD',
                    'GROCERY',
                    'SALON',
                    'CLOTHING',
                    'BAKERY',
                    'THEATER'
                ];
                topicNames = [
                    'Snow Cone Stand',
                    'Beach',
                    'Theme Park',
                    'Arcade',
                    'Fast Food',
                    'Salon',
                    'Clothing Store',
                    'Bakery',
                    'Grocery Store',
                    'Movie Theater',
                ]
                celebrateAudios = ['appfiles/manners/manners_celebrate_please.mp3',
                    'appfiles/manners/manners_celebrate_thank.mp3',
                    'appfiles/manners/manners_celebrate_calm.mp3',
                    'appfiles/manners/manners_celebrate_smile.mp3',
                    'appfiles/manners/manners_celebrate_body_tall.mp3',
                    'appfiles/caring/caring_celebrate_record_take_care_myself.mp3',
                    'appfiles/caring/caring_celebrate_record_take_care_others.mp3',
                    'appfiles/caring/caring_celebrate_record_take_care_world.mp3',
                    'appfiles/caring/caring_celebrate_record_see_fix.mp3',
                    'appfiles/caring/caring_celebrate_record_hard_things.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I am awesome because I say please!"`,
                    `Record yourself in an excited voice and say, "I am awesome because I say thank you!"`,
                    `Record yourself in an excited voice and say, "I am awesome because I talk in a calm voice."`,
                    `Record yourself in an excited voice and say, "I am awesome because I smile!"`,
                    `Record yourself in an excited voice and say, "I am awesome because I keep my body tall!"`,
                    `Record yourself in an excited voice and say, "I believe in me because I take care of myself!"`,
                    `Record yourself in an excited voice and say, "I believe in me because I take care of others!"`,
                    `Record yourself in an excited voice and say, "I believe in me, because I take care of the world!"`,
                    `Record yourself in an excited voice and say, "I believe in me, because I can see it, fix it and make it even better!"`,
                    `Record yourself in an excited voice and say, "I believe in me, because I can do hard things!"`]
                setPractice(
                    <Friends
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                        background={backgrounds[bgIdx]}
                        turns={turns[topicPlay]}
                        texts={texts[topicPlay]}
                        influencerid={influencers[topicPlay]}
                        practiceConversation={getVideo('appfiles/manners/manners_let_watch.gif', login)}
                        practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                        awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                        practiceConversationAudio={'appfiles/freeplay/practice_watch_conversation.mp3'}
                        practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                        awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                        exampleVideo={exampleVideos[topicPlay]}
                        finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                        level={"LEVEL3"}
                        conversation={'COMMUNITY'}
                        title={"Community Locations"}
                        subTitle={topicNames[topicPlay]}
                        topic={codes[topicPlay]}
                    />
                );
                setTopicName(`COMMUNITY_${codes[topicPlay]}`)
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                break;
            default:
                break;
        }
        setDisplaySurpriseVideoIcon(false);
        setDisplayStep3(true)
        // setDisplayMatchGame(true)
        // setDisplayShare(true)
    }

    const onStop = (bought, data) => {
        const position = { x: data.x / clientWidth, y: data.y / clientHeight };
        freeplay.level3Decorate.items = freeplay.level3Decorate.items.map(item => 
            item === bought? {...item, position} : item
        );
        setBoughts(freeplay.level3Decorate.items)
    };

    const goBack = () => {
        if(displayStep1){
            setDisplayStep0(true);  
            setDisplayStep1(false)
        }
        else if(displayStep2){
            setDisplayStep1(true);  
            setDisplayStep2(false);
            setDisplaySurpriseVideoIcon(false);
        }
        else if(displayStep3){
            setDisplayStep2(true); 
            setDisplayStep3(false)
        }
        else if(displayStep3){
            setDisplayStep2(true); 
            setDisplayStep3(false)
        }
        else if(displayStep4){
            setDisplayStep3(true); 
            setDisplayStep4(false)
        }
        else if(displayValuation){
            setDisplayStep3(true); 
            setDisplayValuation(false)
        }
        else{
            navigate("/freeplay_3")
        }
    };

    const checkCompletion = async () => {
        dispatch({ type: `FREEPLAY_SET_LEVEL3_SHAREDCOIN`, payload: 0 });
        switch (conversationNum) {
            case 0:
                if (Object.values(freeplay.level3.favorite).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level3_favorite_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level3/masks/l3_bird_mask.png')} animalName={'bird3'} level={'level3'} topic={'favorite'} width={61} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_3");
                    }
                }
                else{
                    navigate("/freeplay_3");
                }
                break;
            case 1:
                if (Object.values(freeplay.level3.feeling).filter(value => value.unlocked === 1).length === 6) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level3_feeling_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level3/masks/l3_dinossaur_mask.png')} animalName={'dinossaur'} level={'level3'} topic={'feeling'} width={60} height={120} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_3");
                    }
                }
                else{
                    navigate("/freeplay_3");
                }
                break;
            case 2:
                if (Object.values(freeplay.level3.listening).filter(value => value.unlocked === 1).length === 6) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level3_listening_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level3/masks/l3_duck_mask.png')} animalName={'duck'} level={'level3'} topic={'listening'} width={80} height={140} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_3");
                    }
                }
                else{
                    navigate("/freeplay_3");
                }
                break;
            case 3:
                if (Object.values(freeplay.level3.friends).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level3_friends_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level3/masks/l3_giraffe_mask.png')} animalName={'giraffe'} level={'level3'} topic={'friends'} width={60} height={120} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_3");
                    }
                }
                else{
                    navigate("/freeplay_3");
                }
                break;
            case 4:
                if (Object.values(freeplay.level3.solution).filter(value => value.unlocked === 1).length === 3) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level3_solution_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level3/masks/l3_monkey_mask.png')} animalName={'monkey3'} level={'level3'} topic={'solution'} width={60} height={100} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_3");
                    }
                }
                else{
                    navigate("/freeplay_3");
                }
                break;
            case 5:
                if (Object.values(freeplay.level3.conflict).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level3_conflict_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level3/masks/l3_starfish_mask.png')} animalName={'starfish'} level={'level3'} topic={'conflict'} width={150} height={250} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_3");
                    }
                }
                else{
                    navigate("/freeplay_3");
                }
                break;
            case 6:
                if (Object.values(freeplay.level3.advocacy).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level3_advocacy_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level3/masks/l3_trex_mask.png')} animalName={'trex'} level={'level3'} topic={'advocacy'} width={120} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_3");
                    }
                }
                else{
                    navigate("/freeplay_3");
                }
                break;
            case 7:
                if (Object.values(freeplay.level3.community).filter(value => value.unlocked === 1).length === 10) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level3_community_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level3/masks/l3_zebra_mask.png')} animalName={'zebra'} level={'level3'} topic={'community'} width={60} height={120} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_3");
                    }
                }
                else{
                    navigate("/freeplay_3");
                }
                break;
            default:
                break;
        }
    };
    

    const retakePhoto = (item) => {
        let height = 120;
        let width = 60;
        switch(item.animal){
            case "bird":
                height = 160;
                width = 61;
                break;
            case "duck":
                height = 160;
                width = 80; 
                break;
            case "monkey":
                height = 100;
                break;
            case "starfish":
                height = 250;
                width = 150; 
                break;
            case "trex":
                height = 160;
                width = 120; 
                break;
            default:
                break;
        }
        setAnimal(<Animal animal={generateImageUrl(`images/newDesign/FreePlay/level3/masks/l3_${item.animal}_mask.png`)} animalName={item.className} level={'level3'} topic={item.name} width={width} height={height} setDisplayAnimal={setDisplayAnimal}  getAnimals={getAnimals} finish={()=>{setDisplayStoreCharacter(true); setDisplayAnimal(false);}}/>)
        setDisplayStore(false);
        setDisplayStoreCharacter(false);
        setDisplayAnimal(true);
    }

    const getSurprise = async () => {
        let usePhoto = []
        switch(conversationNum){
            case 0:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FAVORITE_COLOR.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module16/Unit4_Mod1_SpecialReward_2.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FAVORITE_ANIMAL.mp4`,
                    },
                ];
                break;
            case 1:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FEELING_CONFIDENT.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module16/Unit4_Mod1_SpecialReward_1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FEELING_HAPPY.mp4`,
                    },
                ];
                break;
            case 2:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_LISTENING_HAPPY.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module17/Unit4_Mod2_Special Dance 2.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_LISTENING_CALM.mp4`,
                    },
                ];
                break;
            case 3:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FRIENDS_SUBJECT.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module17/Unit4_Mod2_Special Dance 1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FRIENDS_OUTSIDE.mp4`,
                    },
                ];
                break;
            case 4:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_SOLUTION_NERVOUS.mp4`,
                    },
                    {
                        video: `influencers/${influencers[2]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module18/Unit4_Mod3_SpecialRewards_Dance 2.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_SOLUTION_SAD.mp4`,
                    },
                ];
                break;
            case 5:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_CONFLICT_SHOP.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module18/Unit4_Mod3_SpecialReward_Dance 1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_CONFLICT_PHOTO.mp4`,
                    },
                ];
                break;
            case 6:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_ADVOCACY_TRAIN.mp4`,
                    },
                    {
                        video: `influencers/${influencers[3]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module19/Unit4_Mod4_SpecialReward_Dance 2.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_ADVOCACY_CARE.mp4`,
                    },
                ];
                break;
            case 7:
            usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_COMMUNITY_FOOD.mp4`,
                    },
                    {
                        video: `influencers/${influencers[4]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module20/Unit4_Mod5_SpecialReward 2.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_COMMUNITY_THEATER.mp4`,
                    },
                ];
                break;
            default:
                break;
        }

        for (let i = 0; i < usePhoto.length; i++) {
            if(usePhoto[i].video.includes("media")){
                usePhoto[i].video = generateImageUrl(usePhoto[i].video)
            }
            else{
                await GetUserVideo(usePhoto[i].video, login).then((data) => {
                    usePhoto[i].video = data;
                });
            }
        }
        
        return usePhoto;
    };
    
    const playSurpriseVideo = async (intro = true) => {
        let music = ""
        switch(conversationNum){
            case 0:
                music = "appfiles/manners/manners_instrumental.m4a"
                break;
            case 1:
                music = "appfiles/manners/manners_instrumental.m4a"
                break;
            case 2:
                music = "appfiles/friends_bullying/friends_bullying_instrumental.m4a"
                break; 
            case 3:
                music = "appfiles/friends_bullying/friends_bullying_instrumental.m4a"
                break; 
            case 4:
                music = "appfiles/expressions/faces_student_instrumental.m4a"
                break; 
            case 5:
                music = "appfiles/expressions/faces_student_instrumental.m4a"
                break; 
            case 6:
                music = "appfiles/posture/posture_student_instrumental.m4a"
                break; 
            case 7:
                music = "appfiles/distance/distance_student_instrumental.m4a"
                break; 
            default:
                break;
        }
        await getSurprise().then((photo) => {
            setSurpriseVideo(
            <Surprise
                background={backgrounds[bgIdx]}
                music={getVideo(music, login)}
                // music={generateImageUrl('media/Freeplay/surprise_intrumental.mp3')}
                introVideo={intro ? 'd6c6b74e964a62fe8a9940bd860c/480.m3u8' : ""}
                slides={photo}
                level3={true}
                setDisplaySurprise={setDisplaySurpriseVideo}
            />
            );
        });
        setDisplaySurpriseVideo(true);
    };

    return (
        <>
        {displaySurpriseVideo && surpriseVideo}
        {!displaySurpriseVideo &&
        <div className='level3Body' style={{ backgroundImage: `url(${backgrounds[bgIdx]})`,  overflowY: "scroll"}}>
            {displayDecorate && !displayStore &&  !displayStoreCharacter &&<div className='decorate' style={{zIndex : !change ? 1 : 0}}>
                    {/* <h2><a onClick={() => {navigate("/freeplay_3")}}>&#60; BACK</a></h2> */}
                    {/* <img className='bin' id='bin' src={Bin}/> */}
                    <img alt='store button' className='store' src={Store} onClick={() => {setDisplayStore(true); setDisplayAnimal(false)}}/>
                    <footer>
                        <h2><a onClick={displayAnimal ? () => {setDisplayAnimal(false); setDisplayStoreCharacter(true)} : () => {navigate("/freeplay_3")}}>&#60; BACK</a></h2>
                    </footer> 
            </div>}
            {(displayStep0 || displayStep1 || displayStep2 || displayCoin || displayCelebrate || displayCoinAfterCelebrate || displayCoinAfterConversation || displayCoinAfterValuation || displayShare) && <header>
                <div className='actions'>
                    {/* {(displayStep1 || displayStep2) && <h2><a onClick={goBack}>&#60; BACK</a></h2>} */}
                    {displaySurpriseVideoIcon && (
                        <img className='surprise' src={giftBtn} alt='Surprise Video' onClick={()=>{playSurpriseVideo(false)}} />
                    )}                
                </div>
                <div className='coins'>
                    <img alt='coin icon' src={coin}/>
                    {freeplay.level3Coin < 10 && <div className='coin1'>{freeplay.level3Coin}</div>}
                    {freeplay.level3Coin >= 10 && freeplay.level3Coin < 100 && <div className='coin10'>{freeplay.level3Coin}</div>}
                    {freeplay.level3Coin >= 100 && <div className='coin100'>{freeplay.level3Coin}</div>}
                </div>
            </header>}
            {(displayStep3 || displayStep4) && <header>
                <img
                    className='back-btn-ftb'
                    alt='back button'
                    src={Exit}
                    onClick={() => {
                        setDisplayStep3(false)
                        setDisplayStep4(false)
                        setDisplayStep1(true)
                    }}
                ></img>
            </header>}
            <footer>
                {(displayStep0 || displayStep1 || displayStep2 || displayStep3 || displayStep4 || displayValuation) && <h2><a onClick={goBack}>&#60; BACK</a></h2>}
                {displayShare && <h2 style={{ position: "fixed", right: "40px", bottom: "20px",}}><a onClick={checkCompletion}>NEXT &#62;</a></h2>}
            </footer> 
            {displayStore && storeReady && <StorePage getAnimals={getAnimals} coin={freeplay.level3Coin} level={"LEVEL3"} decorate={freeplay.level3Decorate} bgs={backgrounds} setBgIdx={setBgIdx} buys={buys} boughts={boughts} setBoughts={setBoughts} close={setDisplayStore} animals={animals} setUpdate={setUpdate} update={update} setChange={setChange} retakePhoto={retakePhoto}/>}
            {displayStoreCharacter && storeReady && <StorePage getAnimals={getAnimals} coin={freeplay.level3Coin} level={"LEVEL3"} decorate={freeplay.level3Decorate} bgs={backgrounds} setBgIdx={setBgIdx} buys={buys} boughts={boughts} setBoughts={setBoughts} close={setDisplayStoreCharacter} animals={animals} setUpdate={setUpdate} update={update} setChange={setChange} retakePhoto={retakePhoto} character={true}/>}
            {displayStep0 && <Intro finish={()=>{setDisplayStep0(false); setDisplayStep1(true)}} setSelectedStudentCharacter={setSelectedStudentCharacter} setSelectedFriendCharacter={setSelectedFriendCharacter}/>}
            {displayStep1 && <div className='conversation'>
                <h2 className='header'>
                    Choose Your Conversation
                </h2>
                <h3 className='text'>
                    Click the conversation you want to practice
                </h3>
                <Container>
                    <Row xs={2} md={3} lg={4}>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(0, 'Favorite Things')}}>
                                <div className='text'>Favorite Things</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level3.favorite).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.favorite).length) ? <div className='optionProgress_completed'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level3.favorite).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level3.favorite).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(1, 'Talk about Feelings')}}>
                                <div className='text'>Talk about Feelings</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level3.feeling).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.feeling).length) ? <div className='optionProgress_completed'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level3.feeling).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level3.feeling).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(2, 'Active Listening')}}>
                                <div className='text'>Active Listening</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level3.listening).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.listening).length) ? <div className='optionProgress_completed'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level3.listening).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level3.listening).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(3, 'Making Friends')}}>
                                <div className='text'>Making Friends</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level3.friends).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.friends).length) ? <div className='optionProgress_completed'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level3.friends).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level3.friends).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(4, 'Solutions')}}>
                                <div className='text'>Solutions</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level3.solution).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.solution).length) ? <div className='optionProgress_completed'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level3.solution).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level3.solution).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(5, 'Resolve Conflict')}}>
                                <div className='text'>Resolve Conflict</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level3.conflict).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.conflict).length) ? <div className='optionProgress_completed'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level3.conflict).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level3.conflict).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(6, 'Self-Advocacy')}}>
                                <div className='text'>Self-Advocacy</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level3.advocacy).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.advocacy).length) ? <div className='optionProgress_completed'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level3.advocacy).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level3.advocacy).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(7, 'Community Locations: Manners & Caring')}}>
                                <div className='text'>Community Locations</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level3.community).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level3.community).length) ? <div className='optionProgress_completed'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level3.community).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level3.community).length} Completed</div>}
                            </div>
                        </Col>
    
                    </Row>
                </Container>
            </div>}
            {displayStep2 && <div className='topic'>
                <h2 className='header'>
                    {conversationName}
                </h2>
                <h3 className='text'>
                    Click the topic you want to practice
                </h3>
                <div className={`conversation_${conversationNum}`}>
                    <Container>
                        <Row xs={2} md={3} lg={4}>
                            {topics.map((topic, index) => (
                                <Col key={index}> 
                                    <div className='option' onClick={() => {settopic(index)}}>
                                        <div className='text'>{topic.text}</div>
                                        <div className='icon'>
                                            <img alt='topic icon' src={topic.img} />
                                        </div>
                                        {topic.completed === 1 && <div className='optionProgress'>Completed</div>}                                 
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </div>
            </div>}
            {displayStep3 && practice}
            {displayCoin && <Coin level={"LEVEL3"} coin={freeplay.level3Coin} close={() => {setDisplayCoin(false); setDisplayValuation(true)}}/>}
            {displayValuation && <Valuation finish={() => {setDisplayValuation(false); setDisplayCoinAfterValuation(true)}} close={() => {setDisplayStep4(false); setDisplayStep2(true)}} name={conversationNames[conversationNum]}  day={getNestedLength(freeplay.level3)} questions={valuationQuestions}/>}
            {displayCoinAfterValuation && <Coin level={"LEVEL3"} coin={freeplay.level3Coin} close={() => { if(conversationNum === 3) {setDisplayCoinAfterValuation(false); setDisplayMatchGame(true)} else{setDisplayCoinAfterValuation(false); setDisplayCelebrate(true)}}}/>}
            {displayMatchGame && <MatchGame background={backgrounds[bgIdx]} onFinish={() => {setDisplayMatchGame(false); setDisplayCoinAfterMatchGame(true)}} onClose={() => {setDisplayMatchGame(false); setDisplayCoinAfterMatchGame(true)}}/>}
            {displayCoinAfterMatchGame && <Coin level={"LEVEL3"} coin={freeplay.level3Coin} close={() => {setDisplayCoinAfterMatchGame(false); setDisplayCelebrate(true)}}/>}
            {displayCelebrate && <Celebrate
              voice1={celebrateVoice}
              voice2={getVideo('appfiles/eye_contact/crab_awesome_job.mp3', login)}
              text={celebrateText}
              name={`level3_celebration_${topicName}.mp4`}
              animation={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
              close={() => {updateProgress(); setDisplayCelebrate(false); setDisplayCoinAfterCelebrate(true)}}
            />}
            {displayCoinAfterCelebrate && <Coin coin={freeplay.level3Coin} level={"LEVEL3"} close={() => {setDisplayCoinAfterCelebrate(false); setDisplayGame(true)}}/>}
            {displayGame && <Game checkCompletion={()=>{setDisplayShare(true); setDisplayGame(false)}} coin={freeplay.level3Coin} level={"LEVEL3"}/>}
            {displayShare && <Share setDisplayShare={setDisplayShare} checkCompletion={checkCompletion} sharedCoin={freeplay.level3SharedCoin}/>}
            {displayAnimal && animal}     
            {prize && (
                <img
                    className='present'
                    style={{
                    width: '84px',
                    height: '100px',
                    marginLeft: '-42px',
                    zIndex: 10,
                    }}
                    id='bounceIcons'
                    src={giftBtn}
                    alt='gift'
                    onClick={() => {
                        playSurpriseVideo();
                        setPrize(false);
                        sleep(2000).then(() => {setDisplayStep1(true);});
                    }}
                />
            )}
            {(prize || displayShare) && (
                <audio autoPlay>
                    <source src={presentSound}></source>
                </audio>
            )}             
            {!displayDecorate && <div className='transparentArea'></div>}
            <div className='decorateArea' style={{zIndex : change ? 1 : 0}}>
                {change && <div className="text">Drag and drop your item</div>}
                <img
                    className='confirmDecorate'
                    style={{opacity : change ? 1 : 0, pointerEvents : change ? "auto" : "none"}}
                    src={greenCheck}
                    alt='confirm button'
                    onClick={()=>{greenCheckSound.play(); setChange(false); setUpdate(!update)}}
                />
                {boughts.map((bought, index) => (
                    <Draggable
                        key={index}
                        disabled={!displayDecorate}
                        bounds='parent'
                        position={{
                        x: bought.position.x * clientWidth,
                        y: bought.position.y * clientHeight,
                        }}
                        onStart={()=>{setChange(true);}}
                        onStop={(e, data) => {
                            onStop(bought, data);
                        }}
                    >
                    {bought.url.includes("https:") ?
                        <div className={`item ${bought.name}`}>
                            <img alt='reward' draggable="false" src={bought.url}/>
                        </div>
                        :
                        <div className={`item level3-${bought.name}`}>
                            <img alt='reward' draggable="false" src={generateImageUrl(bought.url)}/>
                        </div>
                    }
                  </Draggable>
                ))}
            </div>
        </div>}
        </>
    );
};
export default Level3;

